/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/platformLabelInput.scss';

import React from 'react';
import {AwesomeIcon, ChangeFunction, ElementPosition, OrnamentShape} from '@dvrd/dvr-controls';
import {BolmateInput} from "../index";

const infoOrnament = (content: React.ReactNode): OrnamentShape => ({
    element: <div className='platform-label-info-container'>
        <AwesomeIcon name='info-circle' className='info-icon'/>
        {content}
    </div>, placement: ElementPosition.RIGHT
});

const platformLabelInfo = (
    <p className='platform-label-info'>Met deze naam kun je je accounts uit elkaar houden. Voeg bijvoorbeeld
        BE toe als het gaat om een Belgisch verkoopaccount. Deze naam wordt enkel op het Bolmate platform
        getoond om te wisselen tussen je verkoopaccounts en wordt dus niet gebruikt in de communicatie naar
        je klanten.</p>
);

export const emailInfoOrnament = infoOrnament(
  <p className='platform-label-info'>
    Je kunt jouw e-mails verzenden met als afzender jouw eigen e-mailadres of als noreply@bol.com.
    <br />
    Vanwege de werking van bol e-mailsysteem is dit de werking:
    <br /><br />
    Indien je gaat voor jouw eigen e-mailadres, kunnen klanten rechtstreeks reageren op de e-mail maar
      er worden geen e-mail statistieken (open,review klik) verzameld.
    <br /><br />
    Indien je gaat voor het noreply@bol.com e-mailadres, kunnen klanten NIET rechtstreeks op de e-mail reageren
      maar worden er wel e-mail statistieken (open,review klik) verzameld.
    <br /><br />
    De standaard optie is gebruik van het noreply@bol.com e-mailadres.
    <br />
    Je kunt deze keuze aanpassen in de Instellingen &gt; E-mails.
    <br /><br />
    Let op: bij het gebruik van bepaalde kernwoorden in het onderwerp van de mail zal de e-mail ongeacht
      je keuze door het "noreply" adres van Bol verzonden worden.
      Bol geeft aan dat het om de volgende kernwoorden gaat:
    <br />
    onderweg, verstuurd, verzonden, shipped, is geleverd, factuur, bevestiging, track & trace,
      track and trace, nieuwsbrief, wil je ons helpen, bedankt, thank, dankjewel, dankuwel,
      pakbon, wat vindt u van, levering, ingepakt, bezorgd, ingepland, aangemeld, afgeleverd,
      verzending, ontvangen, nota, invoice, pending, planned, received.
  </p>
);

interface Props {
    onChange: ChangeFunction<string>;
    value: string;
    placeholder?: string;
    className?: string;
    label?: string;
    ornament?: OrnamentShape;
    disabled?: boolean;
}

export default function PlatformLabelInput(props: Props) {
    const {placeholder, onChange, value, className, disabled} = props,
        label = props.label ?? 'Herkenbare naam',
        ornament = props.ornament ?? infoOrnament(platformLabelInfo);

    return (
        <BolmateInput onChange={onChange} value={value} label={label} disabled={disabled}
                      inputProps={placeholder ? {placeholder} : undefined} ornaments={ornament}/>
    )
}
